import React, { useEffect, useState } from "react";
import Footer from "./Footer";
import Loader from "./Loader";
import Header from "./Header";
import styled from "styled-components";

const Transformateur_Mono = () => {
  const StyledHeading = styled.h6`
    position: relative;
    font-size: 100px;
    color: #008bcd;

    &::before {
      content: "—";
      font-size: inherit;
      color: #008bcd;
      display: block;
    }
  `;
  // State to control visibility
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Delay the visibility of the component
    const timer = setTimeout(() => {
      setIsVisible(true); // Set to visible after the delay
    }, 200);

    return () => clearTimeout(timer); // Clean up on unmount
  }, []);
  return (
    <div>
      <div>
        <Header />
      </div>
      <Loader isVisible={isVisible} />
      <div>
        {/*=================================
page-title*/}
        <section
          className="page-title bg-overlay-black-60 parallax"
          style={{
            backgroundImage:
              "url(/assets/images/transformateur/Triphase/slider-triphase-36-24.png)",
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="page-title-name">
                  <h1>SACEM INDUSTRIES</h1>
                  <p>innovative Technologies to Bring Electricity</p>
                </div>
                <ul className="page-breadcrumb">
                  <li>
                    <a href="/">
                      <i className="fa fa-home" /> Accueil
                    </a>{" "}
                    <i className="fa fa-angle-double-right" />
                  </li>
                  <li>
                    <span>Transformateur Monphasés</span>{" "}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        {/*=================================
page-title */}
        {/*=================================
 feature */}
        <section className="service white-bg page-section-ptb">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <div className="section-title text-center">
                  <h1 className="title-effect">
                    Nos Gammes de Transformateurs Monophasés
                  </h1>
                </div>
              </div>
            </div>
            {/* ============================================ */}
            {/*=====================================*/}
            {/**<section className="page-section-ptb"> */}
            <section>
              <div className="container">
                <div className="row">
                  <div className="col-lg-6 col-sm-6 mb-30 ">
                    {/** */}
                    <div
                      className="rotateInDownLeft wow"
                      style={{
                        visibility: "visible",
                        animationName: "rotateInDownLeft",
                      }}
                    >
                      <div
                        className="media border p-4"
                        style={{ minHeight: "370px" }}
                      >
                        <div className="feature-icon media-icon mr-4">
                          <span className="ti-settings theme-color1" />
                        </div>
                        <div className="media-body">
                          <h5 className="text-back">
                            CARACTÉRISTIQUES GÉNÉRALES
                          </h5>
                          <br />
                          <p className="mb-0">
                            Transformateur triphasé immergé dans l’huile:
                          </p>
                          <br />
                          <ul className="list list-unstyled list-hand">
                            <li>Norme CEI 60076.</li>
                            <li>
                              Remplissage intégral, hermétique ou respirant.
                            </li>
                            <li>Refroidissement naturel type ONAN.</li>
                            <li>Installation intérieure/extérieure.</li>

                            <li>
                              Couleur: RAL7035 (autres couleurs sur demande).
                            </li>

                            <li>Protection contre la corrosion: C5H.</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    {/** */}
                  </div>
                  <div className="col-lg-6 col-sm-6 mb-30 ">
                    {/** */}
                    <div
                      className="rotateInDownRight wow"
                      style={{
                        visibility: "visible",
                        animationName: "rotateInDownRight",
                      }}
                    >
                      <div
                        className="media border p-4"
                        style={{ minHeight: "370px" }}
                      >
                        <div className="feature-icon media-icon mr-4">
                          <span className="ti-bolt theme-color1" />
                        </div>
                        <div className="media-body">
                          <h5 className="text-back">TENSIONS DE SERVICES</h5>
                          <br />
                          <ul className="list list-unstyled list-hand">
                            <li>Classe: 24 & 36 kV.</li>
                            <li>HT: 17,32 kV.</li>
                            <li>BT: 0,242 kV.</li>
                            <li>Couplage: Monophasé.</li>
                            <li>Fréquence: 50HZ.</li>
                            <li>Conducteur: Cuivre (Aluminium en option).</li>
                            <li>
                              Diélectrique liquide: Huile Minérale selon CEI
                              60296.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    {/** */}
                  </div>
                  {/**
                  <div className="col-lg-6 col-sm-6 xs-mb-30">
                    
                    <div
                      className="rotateInUpLeft wow"
                      style={{
                        visibility: "visible",
                        animationName: "rotateInUpLeft",
                      }}
                    >
                      <div className="media border p-4">
                        <div className="feature-icon media-icon mr-4">
                          <span className="ti-medall theme-color1" />
                        </div>
                        <div className="media-body">
                          <h5 className="text-back">
                            Normes et spécifications
                          </h5>
                          <br />
                          <p className="mb-0">Norme CEI 60076</p>
                          <br />
                          <br />
                          <br />
                          <br />
                          <br />
                          <br />
                          <br />
                          <br />
                          <br />
                          <br />
                          <br />
                        </div>
                      </div>
                    </div>
                     
                  </div>
                  */}
                  <div className="col-lg-6 col-sm-6">
                    {/** */}
                    <div
                      className="rotateInUpLeft wow"
                      style={{
                        visibility: "visible",
                        animationName: "rotateInUpLeft",
                      }}
                    >
                      <div className="media border p-4">
                        <div className="feature-icon media-icon mr-4">
                          <span className="ti-package theme-color1" />
                        </div>
                        <div className="media-body">
                          <h5 className="text-back">ÉQUIPEMENTS DE BASE</h5>
                          <br />
                          <ul className="list list-unstyled list-hand">
                            <li>Anneaux de levage</li>
                            <li>Traversées MT en porcelaine</li>
                            <li>Prises de mise à la terre</li>
                            <li>Dispositif d'accrochage</li>
                            <li>Traversées BT en porcelaine</li>
                            <li>Commutateur de variation hors charge</li>
                            <li>Plaque signalétique</li>
                            <li>Vanne de vidange</li>
                            <li>Soupape de sureté</li>
                            <li>Doigt de gant</li>
                          </ul>

                          <p className="mb-0" style={{ fontWeight: "bold" }}>
                            Note : les options ci-dessus ne sont pas
                            exhaustives.
                          </p>
                        </div>
                      </div>
                    </div>
                    {/** */}
                  </div>
                </div>
              </div>
              <div>
                {/*=================================
 Tableau */}
                <section id="tab36" className="page-section-ptb data-table">
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-12 col-md-12">
                        <h3 style={{ color: "#00356a" }}>
                          DIMENSIONS ET POIDS
                        </h3>
                        <StyledHeading className="h6-line"></StyledHeading>
                        <br />
                        <div className="table-responsive">
                          <table className="table table-1 table-bordered table-striped">
                            <tbody>
                              <tr></tr>
                            </tbody>
                            <thead>
                              <tr>
                                <td>Puissance (kVA)</td>
                                <td>25</td>
                                <td>50</td>
                                <td>75</td>
                                <td>100</td>
                                <td>150</td>
                                <td>210</td>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>L</td>
                                <td>550</td>
                                <td>850</td>
                                <td>920</td>
                                <td>950</td>
                                <td>1100</td>
                                <td>1230</td>
                              </tr>
                              <tr>
                                <td>I</td>
                                <td>580</td>
                                <td>620</td>
                                <td>660</td>
                                <td>680</td>
                                <td>790</td>
                                <td>830</td>
                              </tr>
                              <tr>
                                <td>H</td>
                                <td>1200</td>
                                <td>1200</td>
                                <td>1350</td>
                                <td>1370</td>
                                <td>1480</td>
                                <td>1500</td>
                              </tr>
                              <tr>
                                <td>Poids Huile (Kg)</td>
                                <td>60</td>
                                <td>75</td>
                                <td>110</td>
                                <td>130</td>
                                <td>170</td>
                                <td>250</td>
                              </tr>
                              <tr>
                                <td>Poids Total (kg)</td>
                                <td>250</td>
                                <td>320</td>
                                <td>480</td>
                                <td>600</td>
                                <td>700</td>
                                <td>1040</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                  <div className="row">
                    <div className="entry-button" style={{ marginLeft: 20 }}>
                      <a className="button button-border" href="/contact">
                        Nous Contacter
                      </a>
                    </div>
                    <div className="entry-button" style={{ marginLeft: 20 }}>
                      <a
                        className="button button-border"
                        href="/assets/brochures/catalogue transformateurs 2024 source.pdf"
                      >
                        Catalogue
                      </a>
                    </div>
                  </div>
                </section>
              </div>
            </section>
            {/*=================================
 Tableau */}
          </div>
        </section>
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
};

export default Transformateur_Mono;
